const isoDatePattern = /^\d{4}-\d{2}-\d{2}$/;

export function parseIsoDate(value: string): Date | undefined {
  if (!isoDatePattern.test(value)) {
    return undefined;
  }

  const [year, month, day] = value.split('-').map(Number);

  return new Date(year ?? 0, (month ?? 1) - 1, day ?? 1);
}

export function toIsoDate(date: Date) {
  return date.toLocaleDateString('en-CA');
}

const displayFormatter = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

export function formatIsoDate(value: string) {
  const parsed = parseIsoDate(value);

  return parsed ? displayFormatter.format(parsed) : '';
}

const dayLength = 2;
const monthEnd = 4;
const fullLength = 8;

const keepDigits = (value: string) => value.replace(/\D/g, '');

export function maskDate(value: string) {
  const digits = keepDigits(value).slice(0, fullLength);

  return [digits.slice(0, dayLength), digits.slice(dayLength, monthEnd), digits.slice(monthEnd)]
    .filter((part) => part !== '')
    .join('/');
}

export function toIsoFromMaskedDate(value: string) {
  const digits = keepDigits(value);

  if (digits.length !== fullLength) {
    return '';
  }

  const day = Number(digits.slice(0, dayLength));
  const month = Number(digits.slice(dayLength, monthEnd));
  const year = Number(digits.slice(monthEnd));
  const parsed = new Date(year, month - 1, day);

  const isReal =
    parsed.getFullYear() === year && parsed.getMonth() === month - 1 && parsed.getDate() === day;

  return isReal ? toIsoDate(parsed) : '';
}
